import { render, staticRenderFns } from "./PopEmpresa.vue?vue&type=template&id=745ce94f&scoped=true"
import script from "./PopEmpresa.vue?vue&type=script&lang=js"
export * from "./PopEmpresa.vue?vue&type=script&lang=js"
import style0 from "./PopEmpresa.vue?vue&type=style&index=0&id=745ce94f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745ce94f",
  null
  
)

export default component.exports